import { Alert, AlertIcon, SimpleGrid } from '@chakra-ui/react'

import { FormField } from '../../../../components/FormField'
import { FormSelect } from '../../../../components/Select'
import { IAdmissionVacancyRaw } from '../../../../services/Admission/types'
import { IAdmissionStepProps } from '../admissionForm'

interface IProfessionalStepProps extends IAdmissionStepProps {
  vacancies: IAdmissionVacancyRaw[]
  /** Offered from the full name; `null` while loading. */
  usernames: string[] | null
  vacancyClosed: boolean
  /** Some document was already sent: switching the vacancy may drop it. */
  hasDocuments: boolean
}

export default function ProfessionalStep({
  form,
  update,
  errors,
  isDisabled,
  vacancies,
  usernames,
  vacancyClosed,
  hasDocuments
}: IProfessionalStepProps) {
  return (
    <>
      {vacancyClosed && (
        <Alert status="warning" borderRadius="md" mb={4}>
          <AlertIcon />A vaga que você tinha escolhido foi encerrada. Escolha outra vaga para continuar.
        </Alert>
      )}

      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
        <FormField
          label="Nome de usuário"
          error={errors.username}
          isRequired
          helperText={
            usernames && usernames.length === 0
              ? 'Informe o nome completo, com sobrenome, em Dados pessoais para ver as opções.'
              : 'Gerado a partir do seu nome completo.'
          }
        >
          <FormSelect
            value={form.username}
            onChange={(username) => update({ username })}
            options={(usernames ?? []).map((username) => ({ value: username, label: username }))}
            isLoading={usernames === null}
            isDisabled={isDisabled}
          />
        </FormField>

        <FormField
          label="Cargo"
          error={errors.job_requisition_id}
          isRequired
          helperText={
            hasDocuments
              ? 'Ao trocar de cargo, os documentos já enviados que o novo cargo não pede são descartados.'
              : undefined
          }
        >
          <FormSelect
            value={form.job_requisition_id ?? ''}
            onChange={(value) => update({ job_requisition_id: value ? Number(value) : null })}
            options={vacancies.map((vacancy) => ({ value: vacancy.id, label: vacancy.name }))}
            isDisabled={isDisabled}
          />
        </FormField>
      </SimpleGrid>
    </>
  )
}
